import Vue from "vue";

export default Vue.extend({
  template: `
    <input 
      type="number" 
      @change="changeHandler($event)"
      :value="params.value"
    />
`,
  data() {
    return {
      value: "",
    };
  },
  methods: {
    isPopUp() {
      return false;
    },
    changeHandler(event) {
      this.value = event.target.value;
    },
    getValue() {
      return this.value;
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/gt/shared/ag-grid/AgNumberEditor.js